<div class="w-full space-y-4 border-b border-zinc-200 pb-6 dark:border-zinc-800">
  <div>
    <h4 class="text-sm font-semibold text-primary">Payout trace checklist</h4>
    <p class="mt-1 text-xs text-secondary">
      Trace creator → brief → application → wallet transaction → payout when completion did not trigger a payout.
    </p>
  </div>

  <div class="grid w-full gap-3 sm:grid-cols-2 lg:grid-cols-2">
    @if (!settingsContext.hasBoth()) {
    <p class="sm:col-span-2 text-sm text-amber-800 dark:text-amber-200" role="status">
      Enter brief ID and creator Firebase UID in the context bar above, then run the trace.
    </p>
    }
  </div>

  <button
    type="button"
    class="rounded-lg border border-zinc-300 bg-white px-4 py-2 text-sm font-medium text-primary shadow-sm hover:bg-zinc-50 disabled:opacity-50 dark:border-zinc-600 dark:bg-zinc-900 dark:hover:bg-zinc-800"
    (click)="runTrace()"
    [disabled]="traceLoading() || !settingsContext.hasBoth()"
  >
    @if (traceLoading()) {
      Running trace…
    } @else {
      Run trace
    }
  </button>

  <ol class="w-full space-y-2" aria-label="Payout trace steps">
    @for (step of steps(); track step.key) {
    <li
      class="rounded-lg border border-zinc-200 px-3 py-2.5 dark:border-zinc-800"
      [class.opacity-60]="step.state === 'skipped'"
    >
      <div class="flex flex-row items-start gap-3">
        <span
          class="mt-0.5 inline-flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold"
          [class]="stepIconClass(step.state)"
          aria-hidden="true"
        >
          @switch (step.state) {
          @case ('ok') { ✓ }
          @case ('missing') { ! }
          @case ('error') { × }
          @case ('loading') { … }
          @case ('skipped') { — }
          @default { · }
          }
        </span>
        <div class="min-w-0 flex-1">
          <div class="flex w-full flex-wrap items-baseline gap-x-2 gap-y-0.5">
            <p class="m-0 text-sm font-medium text-primary">{{ step.title }}</p>
            <p class="m-0 text-xs text-secondary">{{ step.summary }}</p>
            @if (step.createdDate) {
            <p class="m-0 ml-auto text-xs tabular-nums text-secondary">{{ step.createdDate }}</p>
            }
          </div>
          @if (step.details.length) {
          <ul class="mt-1.5 space-y-0.5 text-xs text-secondary">
            @for (line of step.details; track line) {
            <li class="font-mono break-all">{{ line }}</li>
            }
          </ul>
          }
        </div>
      </div>
    </li>
    }
  </ol>

</div>
